import { render, staticRenderFns } from "./help-chat-list.vue?vue&type=template&id=4d8dc7be&scoped=true"
import script from "./help-chat-list.vue?vue&type=script&lang=js"
export * from "./help-chat-list.vue?vue&type=script&lang=js"
import style0 from "./help-chat-list.vue?vue&type=style&index=0&id=4d8dc7be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8dc7be",
  null
  
)

export default component.exports